import axios, { CreateAxiosDefaults } from 'axios';
import { getEnv } from '../helper/get-env';

const axiosInit = async () => {
    const axiosOptions: CreateAxiosDefaults = {
        baseURL: await getEnv('BASE_API_URL', true),
        headers: {
            'Content-Type': 'application/json'
        }
    };

    const axiosExpressOptions: CreateAxiosDefaults = {
        baseURL: '/api/',
        headers: {
            'Content-Type': 'application/json'
        }
    };

    const baseApi = axios.create(axiosOptions);
    const publicApi = axios.create(axiosOptions);

    const feApi = axios.create(axiosExpressOptions);

    const { get, post, put, patch, delete: del } = baseApi;
    const baseApiFuncs = { get, post, put, patch, del };

    const {
        get: publicGet,
        post: publicPost,
        put: publicPut,
        patch: publicPatch,
        delete: publicDel
    } = publicApi;

    const publicApiFuncs = {
        publicGet,
        publicPost,
        publicPut,
        publicPatch,
        publicDel
    };

    return {
        ...baseApiFuncs,
        ...publicApiFuncs,
        baseApi,
        feApi
    };
};

export default await axiosInit();
